import PropTypes from 'prop-types';

export const postShapeIsRequired = PropTypes.shape({
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  author: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  post_date: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  header_img: PropTypes.string.isRequired,
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  body: PropTypes.string.isRequired,
});

export const postShape = PropTypes.shape({
  title: PropTypes.string,
  id: PropTypes.number,
  author: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  post_date: PropTypes.string,
  excerpt: PropTypes.string,
  header_img: PropTypes.string,
  category: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  body: PropTypes.string,
});

export const postDefaultProps = {
  title: '',
  id: null,
  author: {
    id: null,
    name: '',
  },
  post_date: '',
  excerpt: '',
  header_img: '',
  category: {
    id: null,
    name: '',
  },
  body: '',
};


export const locationShape = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  key: PropTypes.string,
  pathName: PropTypes.string,
  search: PropTypes.string.isRequired,
  state: PropTypes.objectOf(PropTypes.object),
});

export const locationdefaultProps = {
  state: {},
};

export const matchShape = PropTypes.shape({
  isExact: PropTypes.bool.isRequired,
  params: PropTypes.objectOf(PropTypes.string),
  path: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

export const matchDefaultProps = {
  params: {},
};


export const authorShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  link: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
});

export const authorDefaultProps = PropTypes.shape({
  link: '',
  name: '',
  description: '',
});

export const categoryShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export const tagShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});
